import { parse, format, addDays } from "date-fns";
import store from "../store";
import { parseClockMinutes, formatClockMinutes } from "./Calendar/bookingClockTime.cjs";

export function cleanPhoneNumber(phoneNumber) {
  // Remove all non-digit characters
  let cleaned = phoneNumber.toString().replace(/\D/g, "");

  // If the number starts with "1" (country code for US), remove it
  if (cleaned.startsWith("1")) {
    cleaned = cleaned.substring(1);
  }

  return cleaned;
}

export function removeQueryParam(key) {
  // Create a URL object based on the current window location
  let url = new URL(window.location);

  // Remove the specified query parameter
  url.searchParams.delete(key);

  // Use history.pushState to update the URL without reloading the page
  window.history.pushState({}, "", url);
}

export function formatPhoneNumber(phoneNumber) {
  // Handle undefined, null, or empty values
  if (!phoneNumber) {
    return '';
  }

  // Convert to string if it's a number
  phoneNumber = String(phoneNumber);

  // Remove any leading plus sign and "1" from the phone number
  phoneNumber = phoneNumber.replace(/^\+?1/, "");

  // Check if the phone number is a valid North American phone number
  if (phoneNumber.length !== 10) {
    return phoneNumber; // If the input is not a valid North American phone number, return the input string unchanged
  }

  // Format the phone number with parentheses and dashes
  return (
    "(" +
    phoneNumber.substr(0, 3) +
    ") " +
    phoneNumber.substr(3, 3) +
    "-" +
    phoneNumber.substr(6)
  );
}

export const socialMediaIcons = {
  facebook:
    '<svg width="16" height="16" viewBox="0 0 455 452" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M454.459 227.23C454.459 101.699 352.674 0 227.23 0C101.699 0 0 101.699 0 227.23C0 340.617 83.0666 434.633 191.725 451.661V292.927H134.023V227.244H191.725V177.154C191.725 120.219 225.596 88.7757 277.518 88.7757C302.386 88.7757 328.418 93.2067 328.418 93.2067V149.119H299.716C271.539 149.119 262.734 166.659 262.734 184.624V227.23H325.748L315.622 292.913H262.734V451.647C371.307 434.619 454.459 340.603 454.459 227.215V227.23Z" fill="blue"/></svg>',
  google:
    '<svg width="16" height="16" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M331.376 265.101C325.833 284.386 314.846 301.663 299.733 314.862C284.619 328.061 266.02 336.622 246.165 339.519C230.638 341.772 214.816 340.864 199.649 336.849C184.482 332.835 170.283 325.798 157.903 316.159C145.523 306.521 135.219 294.48 127.608 280.76C119.998 267.04 115.238 251.924 113.615 236.319C112.357 220.652 114.364 204.896 119.508 190.044C124.652 175.193 132.821 161.571 143.499 150.038C154.177 138.506 167.132 129.315 181.544 123.045C195.956 116.776 211.513 113.565 227.229 113.615C241.957 113.636 256.545 116.463 270.214 121.947C272.366 122.913 274.801 123.041 277.043 122.305C279.285 121.57 281.171 120.024 282.333 117.97L309.6 67.7904C310.187 66.6346 310.54 65.3742 310.639 64.0817C310.737 62.7892 310.58 61.4899 310.175 60.2584C309.771 59.0268 309.127 57.8873 308.281 56.9052C307.435 55.9231 306.403 55.1177 305.245 54.5353C275.965 41.2786 243.792 35.6931 211.757 38.3048C179.722 40.9166 148.879 51.6397 122.133 69.4641C95.3868 87.2885 73.6179 111.628 58.8766 140.189C44.1352 168.751 36.9065 200.594 37.8714 232.721C39.7375 280.437 59.3517 325.738 92.8719 359.748C126.392 393.759 171.403 414.029 219.087 416.588C269.038 418.803 317.838 401.172 354.839 367.541C391.839 333.911 414.036 287.012 416.587 237.076C416.587 233.289 416.587 211.513 416.587 199.205C416.539 196.709 415.526 194.329 413.761 192.564C411.995 190.798 409.615 189.785 407.119 189.737H236.697C234.186 189.737 231.778 190.734 230.002 192.51C228.227 194.286 227.229 196.694 227.229 199.205V256.012C227.229 258.523 228.227 260.931 230.002 262.707C231.778 264.483 234.186 265.48 236.697 265.48H331.376" fill="blue"/></svg>',
  instagram:
    '<svg width="16" height="16" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M227.23 0C165.458 0 157.76 0.298276 133.585 1.32094C109.311 2.51404 92.8917 6.278 78.404 11.9026C63.4618 17.7545 50.7353 25.5239 38.1651 38.1651C25.5097 50.7353 17.6693 63.4618 11.9026 78.404C6.278 92.8917 2.51404 109.311 1.32094 133.585C0.227258 157.774 0 165.458 0 227.23C0 289.001 0.298276 296.699 1.32094 320.874C2.51404 345.077 6.278 361.567 11.9026 376.055C17.7545 390.997 25.5239 403.724 38.1651 416.294C50.7353 428.949 63.4618 436.79 78.404 442.556C92.8917 448.11 109.382 451.945 133.585 453.138C157.774 454.232 165.458 454.459 227.23 454.459C289.001 454.459 296.699 454.161 320.874 453.138C345.077 451.945 361.567 448.096 376.055 442.556C390.997 436.705 403.724 428.935 416.294 416.294C428.949 403.724 436.79 391.068 442.556 376.055C448.11 361.567 451.945 345.077 453.138 320.874C454.232 296.685 454.459 289.001 454.459 227.23C454.459 165.458 454.161 157.76 453.138 133.585C451.945 109.382 448.096 92.8065 442.556 78.404C436.705 63.4618 428.935 50.7353 416.294 38.1651C403.724 25.5097 391.068 17.6693 376.055 11.9026C361.567 6.278 345.077 2.51404 320.874 1.32094C296.685 0.227258 289.001 0 227.23 0ZM227.23 40.9064C287.893 40.9064 295.137 41.2047 319.113 42.2274C341.228 43.2642 353.272 46.9572 361.269 50.082C371.936 54.2152 379.393 59.1013 387.461 67.0837C395.372 74.9951 400.258 82.5372 404.391 93.2042C407.516 101.201 411.209 113.245 412.246 135.361C413.269 159.336 413.567 166.594 413.567 227.244C413.567 287.893 413.269 295.151 412.161 319.127C410.968 341.242 407.275 353.287 404.164 361.283C399.86 371.95 395.06 379.407 387.134 387.475C379.137 395.386 371.524 400.272 360.942 404.406C353.045 407.53 340.83 411.223 318.63 412.26C294.526 413.283 287.424 413.581 226.605 413.581C165.785 413.581 158.697 413.283 134.565 412.175C112.45 410.982 100.249 407.289 92.2525 404.178C81.4578 399.875 74.0577 395.074 66.1321 387.148C58.1354 379.152 53.0505 371.538 49.1303 360.957C45.9487 353.059 42.3126 340.844 41.1337 318.644C40.3241 294.825 39.9406 287.439 39.9406 226.903C39.9406 166.395 40.3241 158.995 41.1337 134.878C42.3126 112.677 45.9487 100.491 49.1303 92.565C53.0505 81.7561 58.1496 74.3702 66.1321 66.3735C74.0435 58.4621 81.4578 53.3488 92.2525 49.3434C100.249 46.2328 112.152 42.5399 134.352 41.432C158.456 40.5655 165.557 40.2531 226.292 40.2531L227.23 40.9064ZM227.23 110.604C162.731 110.604 110.575 162.83 110.575 227.258C110.575 291.757 162.802 343.912 227.23 343.912C291.728 343.912 343.884 291.686 343.884 227.258C343.884 162.759 291.657 110.604 227.23 110.604ZM227.23 303.006C185.357 303.006 151.482 269.13 151.482 227.258C151.482 185.386 185.357 151.51 227.23 151.51C269.102 151.51 302.977 185.386 302.977 227.258C302.977 269.13 269.102 303.006 227.23 303.006ZM375.856 105.945C375.856 121.043 363.57 133.23 348.543 133.23C333.444 133.23 321.258 121.029 321.258 105.945C321.258 90.9316 333.529 78.7165 348.543 78.7165C363.556 78.7165 375.856 90.9316 375.856 105.945Z" fill="blue"/></svg>',
  tiktok:
    '<svg width="16" height="16" viewBox="0 0 455 524" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M238.715 0.441361C267.24 0 295.602 0.261547 323.931 0C325.647 33.3636 337.646 67.3484 362.067 90.9367C386.44 115.114 420.916 126.18 454.459 129.924V217.689C423.024 216.659 391.443 210.121 362.918 196.586C350.494 190.962 338.921 183.721 327.592 176.316C327.445 240.002 327.854 303.607 327.184 367.033C325.484 397.503 315.43 427.826 297.71 452.935C269.202 494.733 219.72 521.983 168.898 522.833C137.725 524.615 106.585 516.115 80.0214 500.454C35.9997 474.496 5.02268 426.976 0.510984 375.974C-0.012111 365.071 -0.191925 354.184 0.249436 343.542C4.17265 302.071 24.6878 262.397 56.5312 235.409C92.6247 203.974 143.185 189.001 190.525 197.861C190.966 230.145 189.675 262.397 189.675 294.682C168.048 287.686 142.776 289.647 123.88 302.774C110.083 311.715 99.6047 325.414 94.1449 340.911C89.6332 351.961 90.9246 364.237 91.1862 375.974C96.3681 411.741 130.762 441.802 167.476 438.549C191.817 438.288 215.143 424.164 227.828 403.486C231.931 396.244 236.525 388.839 236.77 380.323C238.911 341.336 238.061 302.512 238.323 263.525C238.503 175.662 238.061 88.0434 238.732 0.457708L238.715 0.441361Z" fill="blue"/></svg>',
  youtube:
    '<svg width="16" height="16" viewBox="0 0 455 318" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M444.972 48.9834C439.574 29.8193 424.629 14.7891 405.379 9.47599C369.935 0.000453014 227.447 0.000455305 227.447 0.000455305C227.447 0.000455305 85.2282 -0.226847 49.4144 9.47599C30.2645 14.8033 15.2485 29.8193 9.90696 48.9834C3.18743 85.3087 -0.151026 122.074 0.00524197 159.01C-0.065789 195.705 3.25846 232.414 9.90696 268.512C15.2485 287.676 30.2645 302.706 49.4144 308.105C84.8589 317.58 227.447 317.58 227.447 317.58C227.447 317.58 369.58 317.58 405.379 308.105C424.629 302.706 439.574 287.69 444.972 268.512C451.493 232.414 454.675 195.705 454.447 159.01C454.675 122.074 451.564 85.3087 444.972 48.9834ZM181.93 227.016V90.7071L300.537 159.01L181.93 227.016Z" fill="blue"/></svg>',
  referral:
    '<svg width="16" height="16" viewBox="0 0 455 401" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M104.805 160.615H34.1362C28.7827 160.59 23.5827 162.403 19.4057 165.752C15.2286 169.1 12.3276 173.781 11.1877 179.012C-3.24583 243.335 -3.71906 310.005 9.79992 374.527L11.2199 381.332C12.3371 386.615 15.2316 391.356 19.4207 394.763C23.6098 398.171 28.8405 400.039 34.2404 400.057H104.81C111.043 400.05 117.02 397.57 121.427 393.162C125.835 388.754 128.315 382.778 128.322 376.544V184.127C128.315 177.892 125.834 171.915 121.426 167.507C117.017 163.099 111.039 160.621 104.805 160.615ZM98.0242 369.764H39.7498L39.4573 368.357C27.1926 309.837 27.2436 249.406 39.6069 190.907H98.0242V369.764Z" fill="blue"/><path d="M453 231.246L432.089 175.483C430.439 171.124 427.504 167.369 423.674 164.714C419.843 162.059 415.297 160.63 410.636 160.615H299.21V132.656L308.272 112.587C312.807 102.543 315.308 91.7001 315.629 80.6844C315.949 69.6686 314.084 58.6985 310.141 48.4078C306.197 38.1171 300.254 28.7098 292.654 20.7294C285.054 12.749 275.947 6.35366 265.861 1.91293C260.346 -0.48861 254.11 -0.634465 248.489 1.50662C242.868 3.64771 238.309 7.90539 235.789 13.3673L159.762 179.799V203.524H182.227L260.113 33.0168C271.108 39.7943 279.258 50.3438 283.041 62.6933C286.823 75.0429 285.979 88.3472 280.666 100.12L270.261 123.162L268.917 129.395V175.761L284.063 190.907H405.518L424.167 240.633V249.41L359.806 362.524H241.531L159.762 314.558V349.678L227.927 389.666C231.444 391.728 235.447 392.816 239.524 392.817H364.102C368.147 392.813 372.12 391.739 375.616 389.705C379.113 387.672 382.011 384.75 384.015 381.236L451.463 262.689C453.425 259.235 454.457 255.331 454.459 251.359V239.291C454.46 236.544 453.966 233.818 453 231.246Z" fill="blue"/></svg>',
  affiliate:
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#2563eb"/><path d="M17 8.5c.83 0 1.5-.67 1.5-1.5S17.83 5.5 17 5.5 15.5 6.17 15.5 7 16.17 8.5 17 8.5zM20 14h-1.5v5H20v-5z" fill="#2563eb"/></svg>',
  affiliatecommission:
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.54 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" fill="#16a34a"/></svg>',
  ["returning customer"]:
    '<svg width="16" height="16" viewBox="0 0 455 436" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M452.552 163.711C450.379 156.97 446.384 150.961 441.007 146.35C435.631 141.74 429.083 138.706 422.09 137.587L312.348 119.752L261.475 20.8941C258.235 14.6007 253.324 9.32142 247.28 5.63564C241.237 1.94986 234.295 0 227.216 0C220.137 0 213.195 1.94986 207.152 5.63564C201.108 9.32142 196.197 14.6007 192.956 20.8941L142.083 119.752L32.3439 137.587C25.3572 138.724 18.8188 141.764 13.446 146.372C8.07316 150.981 4.0736 156.98 1.88612 163.713C-0.30135 170.445 -0.592206 177.649 1.04547 184.536C2.68315 191.422 6.18607 197.725 11.1699 202.752L89.4694 281.684L72.5219 391.563C71.4344 398.562 72.2981 405.725 75.018 412.264C77.7379 418.804 82.2087 424.466 87.9386 428.629C93.6685 432.792 100.435 435.294 107.495 435.86C114.555 436.427 121.634 435.035 127.954 431.838L227.216 381.762L326.48 431.838C332.801 435.028 339.878 436.415 346.935 435.846C353.992 435.277 360.756 432.774 366.484 428.613C372.212 424.451 376.682 418.792 379.404 412.256C382.126 405.72 382.994 398.56 381.913 391.563L364.965 281.684L443.265 202.752C448.264 197.735 451.778 191.432 453.417 184.542C455.056 177.651 454.757 170.441 452.552 163.711ZM421.753 181.416L332.688 271.199L351.969 396.184C352.208 397.681 352.028 399.215 351.448 400.616C350.869 402.017 349.913 403.23 348.687 404.121C347.461 405.012 346.012 405.546 344.501 405.664C342.989 405.782 341.475 405.479 340.125 404.789L227.216 347.828L114.306 404.791C112.956 405.481 111.442 405.783 109.93 405.665C108.419 405.548 106.97 405.013 105.744 404.123C104.517 403.232 103.562 402.019 102.982 400.618C102.403 399.217 102.223 397.683 102.462 396.186L121.744 271.199L32.68 181.415C31.6164 180.34 30.8691 178.994 30.5199 177.523C30.1707 176.052 30.2331 174.513 30.7003 173.075C31.1675 171.637 32.0214 170.355 33.1685 169.37C34.3156 168.386 35.7117 167.735 37.2038 167.491L162.029 147.205L219.896 34.758C220.588 33.4129 221.637 32.2845 222.929 31.4967C224.22 30.7089 225.703 30.2921 227.216 30.2921C228.729 30.2921 230.212 30.7089 231.503 31.4967C232.794 32.2845 233.844 33.4129 234.536 34.758L292.402 147.205L417.228 167.491C418.72 167.735 420.116 168.386 421.263 169.37C422.41 170.355 423.264 171.637 423.731 173.075C424.199 174.513 424.261 176.052 423.912 177.523C423.563 178.994 422.815 180.34 421.752 181.415L421.753 181.416Z" fill="blue"/></svg>',
  other:
    '<svg width="16" height="16" viewBox="0 0 455 692" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M394.934 161.588C357.034 97.3754 303.23 44.0106 238.708 6.63923L227.23 0L215.751 6.63923C150.131 44.5091 95.6432 98.9935 57.7689 164.61C19.8946 230.227 -0.029921 304.662 3.37259e-05 380.425C3.37259e-05 385.36 0.0859998 390.373 0.253628 395.325C2.53452 462.456 28.2074 518.944 74.4972 558.681C109.92 589.09 155.357 607.654 204.312 612.083V691.265H250.159V324.488H204.306V565.942C126.847 556.969 49.7541 502.25 46.0706 393.766C45.9187 389.332 45.8414 384.843 45.8414 380.425C45.9778 315.006 62.6851 250.688 94.404 193.473C126.123 136.258 171.82 88.0116 227.23 53.2356C282.638 88.0123 328.334 136.259 360.052 193.474C391.77 250.689 408.476 315.006 408.612 380.425C408.612 384.843 408.535 389.332 408.383 393.768C405.437 480.552 355.505 532.923 295.994 555V603.522C326.876 594.769 355.513 579.475 379.962 558.678C426.252 518.941 451.925 462.454 454.205 395.323C454.373 390.372 454.459 385.359 454.459 380.423C454.5 303.473 433.947 227.915 394.934 161.588Z" fill="blue"/></svg>',
  none: '<svg width="16" height="16" viewBox="0 0 455 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M454.459 0H0V34.9584H454.459V0Z" fill="blue"/></svg>',
};

export const fileIcons = {
  docx: '<svg id="fi_4725970" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_4_"><path d="m202.718 0h264.814l224.164 233.873v454.622c0 56.868-46.092 102.959-102.959 102.959h-386.019c-56.868 0-102.959-46.092-102.959-102.959v-585.536c0-56.867 46.091-102.959 102.959-102.959z" fill="#0263d1"></path><g fill="#fff"><path clip-rule="evenodd" d="m467.212 0v231.952h224.484z" fill-rule="evenodd" opacity=".302"></path><path d="m195.356 564.73v-131.02h46.412c9.282 0 17.925 1.387 25.927 3.948 8.002 2.667 15.257 6.508 21.766 11.63 6.508 5.121 11.63 11.95 15.364 20.485s5.655 18.351 5.655 29.447-1.921 20.912-5.655 29.447-8.856 15.364-15.364 20.485-13.764 8.962-21.766 11.63c-8.002 2.561-16.644 3.948-25.927 3.948zm32.755-28.487h9.709c5.228 0 10.136-.64 14.51-1.814 4.481-1.28 8.535-3.307 12.376-5.975s6.828-6.508 8.962-11.523c2.241-4.908 3.307-10.883 3.307-17.711s-1.067-12.803-3.307-17.818c-2.134-4.908-5.121-8.749-8.962-11.416-3.841-2.774-7.895-4.694-12.376-5.975-4.374-1.174-9.282-1.814-14.51-1.814h-9.709zm161.855 29.981c-19.738 0-36.062-6.402-48.972-19.098-12.91-12.697-19.312-28.701-19.312-47.905 0-19.205 6.402-35.209 19.312-47.905 12.91-12.697 29.234-19.098 48.972-19.098 19.418 0 35.529 6.402 48.439 19.098 12.803 12.697 19.205 28.701 19.205 47.905s-6.402 35.209-19.205 47.905c-12.91 12.696-29.021 19.098-48.439 19.098zm-25.18-39.37c6.508 7.255 14.83 10.883 24.966 10.883s18.351-3.628 24.86-10.883c6.508-7.362 9.709-16.538 9.709-27.634s-3.201-20.272-9.709-27.634c-6.508-7.255-14.724-10.883-24.86-10.883s-18.458 3.628-24.966 10.883c-6.508 7.362-9.816 16.538-9.816 27.634s3.308 20.272 9.816 27.634zm170.71 39.37c-19.098 0-34.996-5.975-47.585-17.711-12.697-11.843-18.991-28.274-18.991-49.293 0-20.912 6.402-37.343 19.205-49.186 12.91-11.843 28.594-17.818 47.372-17.818 16.964 0 30.834 4.161 41.824 12.59 10.883 8.322 17.178 19.418 18.778 33.288l-33.075 6.722c-1.387-7.255-4.695-13.123-9.816-17.498s-11.096-6.615-17.925-6.615c-9.389 0-17.178 3.308-23.473 10.029-6.295 6.828-9.496 16.217-9.496 28.487s3.201 21.659 9.389 28.381c6.295 6.828 14.084 10.136 23.579 10.136 6.828 0 12.697-1.92 17.498-5.761s7.789-8.962 9.069-15.364l33.822 7.682c-3.094 13.23-9.923 23.473-20.592 30.834-10.562 7.363-23.792 11.097-39.583 11.097z"></path></g></g></g></svg>',
  txt: '<svg id="fi_4726030" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_25_"><path clip-rule="evenodd" d="m202.808 0h264.609l224.265 233.758v454.661c0 56.956-46.079 103.035-102.838 103.035h-386.036c-56.956 0-103.035-46.079-103.035-103.035v-585.384c-.001-56.956 46.078-103.035 103.035-103.035z" fill="#251d36" fill-rule="evenodd"></path><g fill="#fff"><path clip-rule="evenodd" d="m467.219 0v231.978h224.463z" fill-rule="evenodd" opacity=".302"></path><path d="m249.282 577.868v-144.566h-41.135v-31.247h118.857v31.247h-40.937v112.528zm211.411 0h-38.564l-26.303-44.102-26.303 44.102h-38.762l45.684-76.733-39.948-67.042h38.564l20.765 34.807 20.568-34.807h38.762l-39.948 67.24zm44.695 0v-112.528h-40.938v-31.247h118.857v31.247h-41.135v112.528z"></path></g></g></g></svg>',
  png: '<svg id="fi_4725998" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_9_" clip-rule="evenodd" fill-rule="evenodd"><path d="m202.8 0h264.71l224.217 233.922v454.459c0 56.891-46.182 103.073-103.073 103.073h-385.854c-56.891 0-103.073-46.182-103.073-103.073v-585.308c0-56.891 46.182-103.073 103.073-103.073z" fill="#0ac963"></path><g fill="#fff"><path d="m467.176 0v231.914h224.552z" opacity=".302"></path><path d="m496.29 395.56h-201.126c-15.059 0-27.442 12.382-27.442 27.442v127.837c0 15.059 12.382 27.442 27.442 27.442h201.126c15.059 0 27.107-12.382 27.107-27.442v-127.838c0-15.059-12.047-27.441-27.107-27.441zm-146.243 34.469c16.398 0 29.449 13.386 29.449 29.449 0 16.398-13.051 29.784-29.449 29.784s-29.784-13.386-29.784-29.784c0-16.063 13.386-29.449 29.784-29.449zm155.279 120.81c0 5.02-4.016 9.37-9.036 9.37h-201.126c-5.02 0-9.036-4.35-9.036-9.37v-5.354l36.477-36.477 30.119 30.119c3.681 3.681 9.37 3.681 13.051 0l75.632-75.632 63.919 63.919z"></path></g></g></g></svg>',
  jpeg: '<svg id="fi_4725998" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_9_" clip-rule="evenodd" fill-rule="evenodd"><path d="m202.8 0h264.71l224.217 233.922v454.459c0 56.891-46.182 103.073-103.073 103.073h-385.854c-56.891 0-103.073-46.182-103.073-103.073v-585.308c0-56.891 46.182-103.073 103.073-103.073z" fill="#0ac963"></path><g fill="#fff"><path d="m467.176 0v231.914h224.552z" opacity=".302"></path><path d="m496.29 395.56h-201.126c-15.059 0-27.442 12.382-27.442 27.442v127.837c0 15.059 12.382 27.442 27.442 27.442h201.126c15.059 0 27.107-12.382 27.107-27.442v-127.838c0-15.059-12.047-27.441-27.107-27.441zm-146.243 34.469c16.398 0 29.449 13.386 29.449 29.449 0 16.398-13.051 29.784-29.449 29.784s-29.784-13.386-29.784-29.784c0-16.063 13.386-29.449 29.784-29.449zm155.279 120.81c0 5.02-4.016 9.37-9.036 9.37h-201.126c-5.02 0-9.036-4.35-9.036-9.37v-5.354l36.477-36.477 30.119 30.119c3.681 3.681 9.37 3.681 13.051 0l75.632-75.632 63.919 63.919z"></path></g></g></g></svg>',
  webp: '<svg id="fi_4725998" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_9_" clip-rule="evenodd" fill-rule="evenodd"><path d="m202.8 0h264.71l224.217 233.922v454.459c0 56.891-46.182 103.073-103.073 103.073h-385.854c-56.891 0-103.073-46.182-103.073-103.073v-585.308c0-56.891 46.182-103.073 103.073-103.073z" fill="#0ac963"></path><g fill="#fff"><path d="m467.176 0v231.914h224.552z" opacity=".302"></path><path d="m496.29 395.56h-201.126c-15.059 0-27.442 12.382-27.442 27.442v127.837c0 15.059 12.382 27.442 27.442 27.442h201.126c15.059 0 27.107-12.382 27.107-27.442v-127.838c0-15.059-12.047-27.441-27.107-27.441zm-146.243 34.469c16.398 0 29.449 13.386 29.449 29.449 0 16.398-13.051 29.784-29.449 29.784s-29.784-13.386-29.784-29.784c0-16.063 13.386-29.449 29.784-29.449zm155.279 120.81c0 5.02-4.016 9.37-9.036 9.37h-201.126c-5.02 0-9.036-4.35-9.036-9.37v-5.354l36.477-36.477 30.119 30.119c3.681 3.681 9.37 3.681 13.051 0l75.632-75.632 63.919 63.919z"></path></g></g></g></svg>',
  jpg: '<svg id="fi_4725998" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_9_" clip-rule="evenodd" fill-rule="evenodd"><path d="m202.8 0h264.71l224.217 233.922v454.459c0 56.891-46.182 103.073-103.073 103.073h-385.854c-56.891 0-103.073-46.182-103.073-103.073v-585.308c0-56.891 46.182-103.073 103.073-103.073z" fill="#0ac963"></path><g fill="#fff"><path d="m467.176 0v231.914h224.552z" opacity=".302"></path><path d="m496.29 395.56h-201.126c-15.059 0-27.442 12.382-27.442 27.442v127.837c0 15.059 12.382 27.442 27.442 27.442h201.126c15.059 0 27.107-12.382 27.107-27.442v-127.838c0-15.059-12.047-27.441-27.107-27.441zm-146.243 34.469c16.398 0 29.449 13.386 29.449 29.449 0 16.398-13.051 29.784-29.449 29.784s-29.784-13.386-29.784-29.784c0-16.063 13.386-29.449 29.784-29.449zm155.279 120.81c0 5.02-4.016 9.37-9.036 9.37h-201.126c-5.02 0-9.036-4.35-9.036-9.37v-5.354l36.477-36.477 30.119 30.119c3.681 3.681 9.37 3.681 13.051 0l75.632-75.632 63.919 63.919z"></path></g></g></g></svg>',
  pdf: '<svg id="fi_4726010" enable-background="new 0 0 791.454 791.454" height="32" viewBox="0 0 791.454 791.454" width="32" xmlns="http://www.w3.org/2000/svg"><g><g id="Vrstva_x0020_1_15_"><path clip-rule="evenodd" d="m202.808 0h264.609l224.265 233.758v454.661c0 56.956-46.079 103.035-102.838 103.035h-386.036c-56.956 0-103.035-46.079-103.035-103.035v-585.384c-.001-56.956 46.078-103.035 103.035-103.035z" fill="#e5252a" fill-rule="evenodd"></path><g fill="#fff"><path clip-rule="evenodd" d="m467.219 0v231.978h224.463z" fill-rule="evenodd" opacity=".302"></path><path d="m214.278 590.525v-144.566h61.505c15.228 0 27.292 4.153 36.389 12.657 9.097 8.306 13.646 19.579 13.646 33.62s-4.549 25.314-13.646 33.62c-9.097 8.504-21.161 12.657-36.389 12.657h-24.523v52.012zm36.982-83.456h20.37c5.537 0 9.888-1.187 12.855-3.955 2.966-2.571 4.549-6.131 4.549-10.877s-1.582-8.306-4.549-10.877c-2.966-2.769-7.317-3.955-12.855-3.955h-20.37zm89.785 83.456v-144.566h51.221c10.086 0 19.579 1.384 28.478 4.351 8.899 2.966 17.008 7.12 24.127 12.855 7.12 5.537 12.855 13.052 17.008 22.545 3.955 9.493 6.131 20.37 6.131 32.631 0 12.064-2.175 22.941-6.131 32.433-4.153 9.493-9.888 17.008-17.008 22.545-7.12 5.735-15.228 9.888-24.127 12.855-8.899 2.966-18.392 4.351-28.478 4.351zm36.191-31.444h10.679c5.735 0 11.075-.593 16.019-1.978 4.746-1.384 9.295-3.56 13.646-6.526 4.153-2.966 7.515-7.12 9.888-12.657s3.56-12.064 3.56-19.579c0-7.713-1.187-14.239-3.56-19.776s-5.735-9.69-9.888-12.657c-4.351-2.966-8.899-5.142-13.646-6.526-4.944-1.384-10.284-1.978-16.019-1.978h-10.679zm109.364 31.444v-144.566h102.838v31.445h-65.856v23.138h52.605v31.247h-52.605v58.736z"></path></g></g></g></svg>',
};

export function unixToYearMonthDay(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000);
  const year = date.getFullYear().toString();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[date.getMonth()];
  const day = date.getDate().toString().padStart(2, "0");

  return { year, month, day };
}

export function convertTo24HourFormat(time12h) {
  // Parse the time string using date-fns
  const parsedDate = parse(time12h, "h:mm a", new Date());

  // Format the parsed date to 24-hour time format
  const time24h = format(parsedDate, "HH:mm");

  return time24h;
}

export function formatDay(day) {
  if (day < 10 && day.toString().length < 2) {
    return "0" + day;
  } else {
    return day.toString();
  }
}

/**
 * Returns all day keys in a mainBookings/otherBookings month doc that contain the given bookingId.
 * Use when updating an existing booking so we write to the same key (e.g. "2" or "02") as in the doc.
 * @param {Object} docData - Result of docSnap.data() for a mainBookings/{year}/{month} doc
 * @param {string} bookingId - Booking ID to find
 * @returns {string[]} Array of day keys (e.g. ["2"] or ["2", "3", "4"] for multi-day)
 */
export function getActualDayKeysForBooking(docData, bookingId) {
  if (!docData || !bookingId) return [];
  return Object.keys(docData).filter(
    (k) => /^\d{1,2}$/.test(k) && docData[k] && typeof docData[k] === "object" && docData[k][bookingId]
  );
}

/**
 * Returns the first day key in the doc that contains the given bookingId, or null.
 * Use for single-day updates when you only need one key.
 * @param {Object} docData - Result of docSnap.data() for a mainBookings/{year}/{month} doc
 * @param {string} bookingId - Booking ID to find
 * @returns {string|null}
 */
export function getActualDayKeyForBooking(docData, bookingId) {
  const keys = getActualDayKeysForBooking(docData, bookingId);
  return keys.length > 0 ? keys[0] : null;
}

/** Logged once per session when timezone fallback is used (avoids console flood) */
let _hasLoggedTimezoneFallback = false;

/**
 * Returns the user's timezone from store config, or a safe fallback.
 * Use this whenever passing timezone to date-fns-tz to avoid crashes
 * when userConfig hasn't loaded yet.
 */
export function getUserTimezone() {
  const tz = store.state.userConfig?.companyDetails?.timeZone;
  if (tz && typeof tz === 'string') return tz;
  if (!_hasLoggedTimezoneFallback) {
    _hasLoggedTimezoneFallback = true;
    console.warn('[TintBolt] userConfig.companyDetails.timeZone is missing; using fallback. Check Account settings.');
  }
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

export function formatDateString(dateStr) {
  //Date string format: "2021-07-14"
  // Define the month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Extract the date components from the string
  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(5, 7);
  const day = dateStr.substring(8, 10);

  // Convert the month from "07" to "July"
  const monthName = monthNames[parseInt(month, 10) - 1];

  // Format the date as "Month day, year"
  return { month: monthName, day: day, year: year };
}

export function convertTo12HourFormat(timeStr) {
  if (!timeStr || typeof timeStr !== 'string') return '';
  const minutes = parseClockMinutes(timeStr);
  // Keep unrecognized values visible rather than inventing a valid time.
  return minutes === null ? timeStr : formatClockMinutes(minutes);
}

// --- Date and Time Functions ---

export function timeDifferenceInMinutes(startTime, endTime) {
  function timeToMinutes(time) {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);
  return endMinutes - startMinutes;
}

// --- Remove Leading Zero From Day Str ---

export function removeLeadingZero(dayStr) {
  return dayStr.startsWith("0") ? dayStr.substring(1) : dayStr;
}

export function formatDateComponents(dateStr) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Extract the date components from the date string
  const [year, month, day] = dateStr.split("-");

  // Convert the month from "07" to "July"
  const monthName = monthNames[parseInt(month, 10) - 1];

  // Format the date components
  return {
    month: monthName,
    day: day,
    year: year,
  };
}

export function findTimeslot(availabilityArray, customerSelection, duration = 60) {

  if (!availabilityArray || !customerSelection) {
    return { humanVersion: '', rawVersion: '' };
  }

  // Handle array of time ranges (e.g., ["10:00-10:30", ...] or multi-day slot objects)
  if (Array.isArray(availabilityArray)) {
    // Normalize customer selection to 24h format with leading zeros
    const normalizedSelection = customerSelection.length === 4 ? `0${customerSelection}` : customerSelection;
    
    // Find the slot that starts with the selected time
    // Handle both string slots ("09:00-13:00") and multi-day slot objects
    const timeslot = availabilityArray.find(slot => {
      // Handle multi-day slot objects
      if (slot && typeof slot === 'object' && slot.isMultiDay) {
        return slot.startTime === normalizedSelection;
      }
      // Handle string slots
      if (typeof slot === 'string') {
        const [start] = slot.split('-');
        return start === normalizedSelection;
      }
      return false;
    });

    if (!timeslot) return { humanVersion: '', rawVersion: '' };

    // Extract start and end times based on slot type
    let start, end;
    if (timeslot && typeof timeslot === 'object' && timeslot.isMultiDay) {
      // Multi-day slot: use startTime and endTime from the object
      start = timeslot.startTime;
      end = timeslot.endTime;
      // For multi-day slots, create a string version for rawVersion
      const rawVersion = `${start}-${end}`;
      
      // Format for display
      const humanStart = convertTo12HourFormat(start);
      const humanEnd = convertTo12HourFormat(end);
      
      return { 
        humanVersion: `${humanStart} - ${humanEnd}`,
        rawVersion: rawVersion,
        startTime: start,
        endTime: end,
        isMultiDay: true,
        slotDetails: timeslot.slotDetails,
        totalDays: timeslot.totalDays
      };
    } else if (typeof timeslot === 'string') {
      // Single-day string slot
      const [startTime, endTime] = timeslot.split('-');
      start = startTime;
      end = endTime;
      
      // Format for display
      const humanStart = convertTo12HourFormat(start);
      const humanEnd = convertTo12HourFormat(end);
      
      return { 
        humanVersion: `${humanStart} - ${humanEnd}`,
        rawVersion: timeslot,
        startTime: start,
        endTime: end
      };
    }
  }

  return { humanVersion: '', rawVersion: '' };
}

export function formatTimezoneDateString(dateString) {
  // Extract the date and time parts from the string
  const [datePart, timePart] = dateString.split("T");
  const [selectedYear, month, selectedDay] = datePart.split("-");

  // Parse the time offset
  // const offsetSign = timePart[timePart.length - 6];
  // const offsetHours = timePart.slice(timePart.length - 5, timePart.length - 3);
  // const offsetMinutes = timePart.slice(timePart.length - 2);

  // Create a map of month numbers to month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Convert month number to full month name
  const selectedMonth = monthNames[parseInt(month, 10) - 1];

  // Return the formatted string
  return { selectedYear, selectedMonth, selectedDay, month };
}

export async function copyLink(link) {
  try {
    await navigator.clipboard.writeText(link);
    linkCopied.value = true;
    setTimeout(() => {
      linkCopied.value = false;
    }, 2000);
  } catch (err) {
    console.error("Failed to copy link: ", err);
  }
}

export function validPlan(requiredPlan) {
  // This function will check if the user has the required plan to access a certain feature. It will return a boolean value.
  if (store.state.userConfig.plan.toLowerCase() === "pro+") {
    return true;
  }
  if (requiredPlan.includes(store.state.userConfig.plan)) {
    return true;
  } else {
    return false;
  }
}

// Function to get the darker RGB value
export function getDarkerRGBFromTailwindClass(tailwindClass, shadesDarker = 3) {
  const tailwindColors = {
    yellow: {
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
    },
    green: {
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
    },
    red: {
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
    },
    blue: {
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
    },
    purple: {
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
    },
    pink: {
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
    },
    orange: {
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
    },
    lime: {
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
    },
    teal: {
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
    },
    sky: {
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
    },
  };
  const match = tailwindClass.match(/bg-([a-z]+)-(\d+)/);
  if (!match) return null;

  const [_, color, shade] = match;
  const shadeInt = parseInt(shade, 10);

  // Calculate the new shade (shadesDarker shades darker)
  const newShadeInt = shadeInt + shadesDarker * 100;
  const newShade = newShadeInt > 900 ? 900 : newShadeInt; // Ensure max is 900

  // Get the new RGB color value
  const newColor = tailwindColors[color][newShade];
  return newColor || null;
}

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * Returns all calendar days for a multi-day booking from start date and count.
 * Used so getBookingDaysToUpdate can derive the full list across months without relying on month-scoped data.
 * @param {string} startDateStr - YYYY-MM-DD
 * @param {number} totalDays - number of days (matches details.totalDays / total_days at creation)
 * @param {boolean} [skipWeekends=false] - when true, skip Saturday/Sunday to match creation when blockWorkHoursOnly was used
 * @returns {Array<{ year: string, month: string, day: string }>}
 */
export function getMultiDayCalendarDays(startDateStr, totalDays, skipWeekends = false) {
  if (!startDateStr || !totalDays || totalDays < 1) {
    return [];
  }
  const parts = startDateStr.split('-').map(Number);
  if (parts.length !== 3 || isNaN(parts[0]) || isNaN(parts[1]) || isNaN(parts[2])) {
    return [];
  }
  const start = new Date(parts[0], parts[1] - 1, parts[2]);
  if (isNaN(start.getTime())) {
    return [];
  }
  const out = [];
  let current = new Date(start.getTime());
  let collected = 0;
  while (collected < totalDays) {
    if (skipWeekends) {
      const dow = current.getDay();
      if (dow === 0 || dow === 6) {
        current = addDays(current, 1);
        continue;
      }
    }
    const y = String(current.getFullYear());
    const monthIndex = current.getMonth();
    const monthName = months[monthIndex];
    const d = current.getDate();
    out.push({ year: y, month: monthName, day: formatDay(String(d).padStart(2, '0')) });
    collected += 1;
    current = addDays(current, 1);
  }
  return out;
}

/**
 * Returns all days for a booking (one for single-day, many for multi-day).
 * Used so updates (projection, lock, meta, etc.) can be applied to every day across months.
 * @param {Object} bookingData - Full details[1] (booking payload with installDetails/serviceDetails, _multiDayEntries)
 * @returns {Array<{ year: string, month: string, day: string }>}
 */
export function getBookingDaysToUpdate(bookingData) {
  if (!bookingData) return [];
  const details = bookingData.booking?.installDetails ?? bookingData.serviceDetails;
  if (!details) {
    return [];
  }

  const isMultiDay = details.isMultiDay === true ||
    details.totalDays > 1 ||
    (details.timeslots && Array.isArray(details.timeslots) && details.timeslots.length > 1) ||
    bookingData.is_multi_day === true ||
    bookingData.total_days > 1;

  // For multi-day, derive full list from start date + totalDays so all months are updated (not just current month's data).
  if (isMultiDay) {
    let startDateStr = null;
    let totalDaysNum = details.totalDays ?? bookingData.total_days;
    if (totalDaysNum != null) totalDaysNum = Number(totalDaysNum);

    if (details.timeslots && Array.isArray(details.timeslots) && details.timeslots.length > 1 && details.timeslots[0]?.date) {
      startDateStr = details.timeslots[0].date;
    }
    if (!startDateStr && bookingData._multiDayEntries && Array.isArray(bookingData._multiDayEntries) && bookingData._multiDayEntries.length > 0) {
      const first = bookingData._multiDayEntries[0];
      startDateStr = first?.slot_detail?.date;
      if (!startDateStr && first?.booking?.installDetails) {
        const inst = first.booking.installDetails;
        if (inst.selectedYear && inst.selectedMonth != null && inst.selectedDay != null) {
          const mi = months.indexOf(inst.selectedMonth) + 1;
          startDateStr = `${inst.selectedYear}-${String(mi).padStart(2, '0')}-${formatDay(inst.selectedDay)}`;
        }
      }
      if (!startDateStr && first?.serviceDetails) {
        const svc = first.serviceDetails;
        if (svc.selectedYear && svc.selectedMonth != null && svc.selectedDay != null) {
          const mi = months.indexOf(svc.selectedMonth) + 1;
          startDateStr = `${svc.selectedYear}-${String(mi).padStart(2, '0')}-${formatDay(svc.selectedDay)}`;
        }
      }
    }
    if (!startDateStr && details.selectedYear && details.selectedMonth != null && details.selectedDay != null) {
      const mi = months.indexOf(details.selectedMonth) + 1;
      if (mi >= 1 && mi <= 12) {
        startDateStr = `${details.selectedYear}-${String(mi).padStart(2, '0')}-${formatDay(details.selectedDay)}`;
      }
    }

    if (startDateStr && /^\d{4}-\d{2}-\d{2}$/.test(startDateStr) && totalDaysNum >= 1) {
      const skipWeekends = details.blockWorkHoursOnly === true;
      const fromRange = getMultiDayCalendarDays(startDateStr, totalDaysNum, skipWeekends);
      if (fromRange.length > 0) {
        return fromRange;
      }
    }
  }

  const out = [];

  if (isMultiDay && details.timeslots && Array.isArray(details.timeslots) && details.timeslots.length > 1) {
    for (const slot of details.timeslots) {
      if (!slot || !slot.date) continue;
      const [y, m, d] = slot.date.split('-');
      if (y && m && d) {
        const monthIndex = parseInt(m, 10) - 1;
        if (monthIndex >= 0 && monthIndex < months.length) {
          out.push({ year: y, month: months[monthIndex], day: formatDay(d) });
        }
      }
    }
  }

  if (out.length === 0 && bookingData._multiDayEntries && Array.isArray(bookingData._multiDayEntries) && bookingData._multiDayEntries.length > 0) {
    for (const entry of bookingData._multiDayEntries) {
      let dateStr = entry?.slot_detail?.date;
      if (!dateStr && entry?.booking?.installDetails) {
        const inst = entry.booking.installDetails;
        if (inst.selectedYear && inst.selectedMonth != null && inst.selectedDay != null) {
          const mi = months.indexOf(inst.selectedMonth) + 1;
          dateStr = `${inst.selectedYear}-${String(mi).padStart(2, '0')}-${formatDay(inst.selectedDay)}`;
        }
        if (!dateStr && entry?.serviceDetails) {
          const svc = entry.serviceDetails;
          if (svc.selectedYear && svc.selectedMonth != null && svc.selectedDay != null) {
            const mi = months.indexOf(svc.selectedMonth) + 1;
            dateStr = `${svc.selectedYear}-${String(mi).padStart(2, '0')}-${formatDay(svc.selectedDay)}`;
          }
        }
      }
      if (!dateStr) continue;
      const [y, m, d] = dateStr.split('-');
      if (y && m && d) {
        const monthIndex = parseInt(m, 10) - 1;
        if (monthIndex >= 0 && monthIndex < months.length) {
          out.push({ year: y, month: months[monthIndex], day: formatDay(d) });
        }
      }
    }
  }

  if (out.length === 0) {
    const y = details.selectedYear;
    const m = details.selectedMonth;
    const d = details.selectedDay;
    if (y && m != null && d != null) {
      out.push({ year: String(y), month: m, day: formatDay(d) });
    }
  }

  return out;
}

export const getTimeslotsWithAvailability = (date, increment = 60, availabilityData = [], businessHours = null) => {
  const times = [];
  
  // Ensure we're working with a proper Date object and local time
  let currentTime;
  if (date instanceof Date) {
    currentTime = new Date(date);
  } else if (typeof date === 'string') {
    // Parse date string and create date in local timezone
    const [year, month, day] = date.split('-').map(Number);
    currentTime = new Date(year, month - 1, day, 0, 0, 0);
  } else {
    currentTime = new Date(date);
  }
  
  currentTime.setHours(0, 0, 0, 0); // Start of availability hours
  
  const endTime = new Date(currentTime);
  endTime.setHours(24, 0, 0, 0); // End of availability hours

  // Parse business hours if provided
  let businessStartMinutes = null;
  let businessEndMinutes = null;
  if (businessHours && businessHours.startTime && businessHours.endTime) {
    const parseTime = (timeStr) => {
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    };
    businessStartMinutes = parseTime(businessHours.startTime);
    businessEndMinutes = parseTime(businessHours.endTime);
  }

  // Note: When returnAllSlots is true, availabilityData contains ALL slots (including conflicted ones) with hasConflict flag
  // When returnAllSlots is false, availabilityData only contains available slots (legacy behavior)
  // We mark the START times of returned slots as available, and check for hasConflict flag for UI styling

  while (currentTime < endTime) {
    // Use consistent HH:mm format instead of toLocaleTimeString
    // This ensures exact matching with the format used in getAvailableTimeSlots
    const hours = currentTime.getHours().toString().padStart(2, '0');
    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
    const timeString = `${hours}:${minutes}`;
    const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();
    
    // Check if this is a multi-day slot start time (for special handling)
    let multiDaySlot = null;
    if (availabilityData && availabilityData.length > 0) {
      // First, try to find a multi-day slot matching this time
      multiDaySlot = availabilityData.find(slot => {
        if (typeof slot === 'object' && slot.isMultiDay) {
          return slot.startTime === timeString;
        }
        return false;
      });
    }
    
    // Determine availability:
    // When returnAllSlots is true, backend returns all slots including conflicted ones with hasConflict flag
    // When returnAllSlots is false, backend only returns available slots (legacy behavior)
    let isAvailable = false;
    let hasConflict = false;
    let matchingSlot = null;
    let originalSlotString = null; // Preserve original slot string for detecting 24:00 end times
    
    if (availabilityData && availabilityData.length > 0) {
      // Check for slots matching this time string
      matchingSlot = availabilityData.find(slot => {
        if (!slot) return false;
        
        // Single-day slot (string format): "09:00-13:00"
        if (typeof slot === 'string') {
          const [start] = slot.split('-');
          return start === timeString;
        }
        
        // Single-day slot (object format with hasConflict): { slot: "09:00-13:00", hasConflict: true/false }
        if (typeof slot === 'object' && slot.slot && !slot.isMultiDay) {
          const [start] = slot.slot.split('-');
          return start === timeString;
        }
        
        // Multi-day slot (object format)
        if (typeof slot === 'object' && slot.isMultiDay) {
          return slot.startTime === timeString;
        }
        
        return false;
      });
      
      if (matchingSlot) {
        isAvailable = true; // Slot exists, so it's available (even if conflicted)
        
        // Check for conflict flag
        if (typeof matchingSlot === 'object') {
          hasConflict = matchingSlot.hasConflict === true;
          
          // Always use matchingSlot if it's a multi-day slot (most reliable source)
          // This ensures multi-day info is always available for display
          if (matchingSlot.isMultiDay) {
            multiDaySlot = matchingSlot;
          }
        }
        
        // Preserve the original slot string for detecting 24:00 end times
        if (typeof matchingSlot === 'string') {
          originalSlotString = matchingSlot;
        } else if (typeof matchingSlot === 'object' && matchingSlot.slot) {
          originalSlotString = matchingSlot.slot;
        }
      }
    }
    

    times.push({
      time: timeString,
      available: isAvailable,
      hasConflict: hasConflict, // Add conflict flag for UI styling
      isMultiDay: multiDaySlot ? true : false,
      multiDayInfo: multiDaySlot || null,
      // Preserve the original slot string if it exists (for detecting 24:00 end times)
      originalSlot: originalSlotString
    });

    currentTime.setMinutes(currentTime.getMinutes() + increment);
  }

  return times;
};

/**
 * Calculate end time for a single-day slot based on start time and duration
 * @param {string} startTime - Start time in HH:mm format
 * @param {number} duration - Duration in minutes
 * @returns {string} End time in HH:mm format
 */
export function calculateSingleDayEndTime(startTime, duration) {
  if (!startTime || typeof startTime !== 'string') return '';
  
  const [hours, minutes] = startTime.split(':').map(Number);
  const startMinutes = hours * 60 + minutes;
  const endMinutes = startMinutes + duration;
  
  // Cap at 23:59 for single-day slots (don't wrap to next day)
  const maxMinutes = 23 * 60 + 59;
  const finalEndMinutes = Math.min(endMinutes, maxMinutes);
  
  const endHours = Math.floor(finalEndMinutes / 60);
  const endMins = finalEndMinutes % 60;
  
  return `${String(endHours).padStart(2, '0')}:${String(endMins).padStart(2, '0')}`;
}

/**
 * Format time slot display with start and end dates/times
 * @param {object|string} slot - Time slot object or string
 * @param {string|Date} selectedDate - Selected booking date (YYYY-MM-DD or Date object)
 * @param {number} duration - Duration in minutes (for single-day slots)
 * @param {object} businessHours - Optional business hours object with startTime and endTime
 * @returns {object} Object with start, end strings and isMultiDay boolean
 */
export function formatTimeSlotDisplay(slot, selectedDate, duration = 60, businessHours = null) {
  // Parse selectedDate to Date object
  let dateObj;
  if (selectedDate instanceof Date) {
    dateObj = selectedDate;
  } else if (typeof selectedDate === 'string' && selectedDate.trim() !== '') {
    // Handle YYYY-MM-DD format
    const parts = selectedDate.split('-');
    if (parts.length === 3) {
      const [year, month, day] = parts.map(Number);
      if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
        dateObj = new Date(year, month - 1, day);
      } else {
        dateObj = new Date();
      }
    } else {
      dateObj = new Date();
    }
  } else {
    // Fallback to current date
    dateObj = new Date();
  }
  
  // Format date helper
  const formatDate = (date) => {
    return format(date, 'MMM d, yyyy');
  };
  
  // Helper to parse time string to minutes
  const parseTimeToMinutes = (timeStr) => {
    const parts = timeStr.split(':');
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    return hours * 60 + minutes;
  };
  
  // Helper to get business hours for a date (similar to BookingTime.vue)
  const getBusinessHoursForDate = (dateString) => {
    if (!dateString) return null;
    
    // Parse the date to get day of week
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const dayOfWeek = date.getDay(); // 0 = Sunday, 6 = Saturday
    
    // Day names matching the format used in companyProfile
    const dayNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const dayName = dayNames[dayOfWeek];
    const dayNamesAbbr = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const dayNameAbbr = dayNamesAbbr[dayOfWeek];
    
    // Try to get business hours from store
    if (store.state.companyPublicProfile?.businessHours?.periods) {
      const periods = store.state.companyPublicProfile.businessHours.periods;
      const dayPeriod = periods.find(p => {
        const pDay = p.dayOfWeek?.toUpperCase();
        return pDay === dayName || pDay === dayNameAbbr;
      });
      if (dayPeriod && dayPeriod.open && dayPeriod.startLocalTime && dayPeriod.endLocalTime) {
        return {
          startTime: dayPeriod.startLocalTime,
          endTime: dayPeriod.endLocalTime
        };
      }
    }
    
    // Fallback to passed businessHours if available
    return businessHours;
  };
  
  // Calculate available minutes per day from business hours
  let availableMinutesPerDay = 8 * 60; // Default 8 hours
  const dateStr = typeof selectedDate === 'string' ? selectedDate : format(selectedDate, 'yyyy-MM-dd');
  const dayBusinessHours = getBusinessHoursForDate(dateStr) || businessHours;
  if (dayBusinessHours && dayBusinessHours.startTime && dayBusinessHours.endTime) {
    const startMins = parseTimeToMinutes(dayBusinessHours.startTime.split(':').slice(0, 2).join(':'));
    const endMins = parseTimeToMinutes(dayBusinessHours.endTime.split(':').slice(0, 2).join(':'));
    availableMinutesPerDay = endMins - startMins;
  }
  
  // Handle multi-day slots - check for multiDayInfo first
  // The slot might be from getTimeslotsWithAvailability which has isMultiDay and multiDayInfo properties
  if (slot && typeof slot === 'object') {
    // Check if this is a multi-day slot (from getTimeslotsWithAvailability)
    if (slot.isMultiDay && slot.multiDayInfo) {
      const multiDayInfo = slot.multiDayInfo;
      
      // FIRST: Try to use displayText if available - it's pre-formatted by the backend with correct dates
      // This is the most reliable source since backend calculates it correctly
      // Format: "June 15 9:00 AM - June 17 2:00 PM" or "Jan 22, 2026 8:00 AM - Jan 24, 2026 5:00 PM"
      // Normalize full month names to short form (Feb vs February) for consistent display
      if (multiDayInfo.displayText) {
        const parts = multiDayInfo.displayText.split(' - ');
        if (parts.length === 2) {
          const toShortMonth = (str) => str.replace(/\b(January|February|March|April|May|June|July|August|September|October|November|December)\b/g,
            (m) => ({ January: 'Jan', February: 'Feb', March: 'Mar', April: 'Apr', May: 'May', June: 'Jun', July: 'Jul', August: 'Aug', September: 'Sep', October: 'Oct', November: 'Nov', December: 'Dec' }[m] || m));
          return {
            start: toShortMonth(parts[0].trim()),
            end: toShortMonth(parts[1].trim()),
            isMultiDay: true
          };
        }
      }
      
      // SECOND: Use slotDetails array (same logic as selectedTimeRange in BookingTime.vue)
      // Check if we have slotDetails for proper date range display
      if (multiDayInfo.slotDetails && Array.isArray(multiDayInfo.slotDetails) && multiDayInfo.slotDetails.length > 0) {
        const firstSlot = multiDayInfo.slotDetails[0];
        const lastSlot = multiDayInfo.slotDetails[multiDayInfo.slotDetails.length - 1];
        
        // Extract dates and times from slotDetails (same logic as selectedTimeRange)
        if (firstSlot.date && lastSlot.date) {
          const firstStartTime = firstSlot.startTime || firstSlot.start_time;
          const lastEndTime = lastSlot.endTime || lastSlot.end_time;
          
          if (firstStartTime && lastEndTime) {
            const [startYear, startMonth, startDay] = firstSlot.date.split('-').map(Number);
            const startDate = new Date(startYear, startMonth - 1, startDay);
            const [endYear, endMonth, endDay] = lastSlot.date.split('-').map(Number);
            const endDate = new Date(endYear, endMonth - 1, endDay);
            
            // Use the same format as selectedTimeRange: 'MMM d, yyyy'
            const startFormatted = format(startDate, 'MMM d, yyyy');
            const endFormatted = format(endDate, 'MMM d, yyyy');
            const startTimeFormatted = convertTo12HourFormat(firstStartTime);
            const endTimeFormatted = convertTo12HourFormat(lastEndTime);
            
            return {
              start: `${startFormatted} ${startTimeFormatted}`,
              end: `${endFormatted} ${endTimeFormatted}`,
              isMultiDay: true
            };
          }
        }
      }
      
      // Last fallback: use startTime and endTime from multiDayInfo
      // For multi-day slots, we should never reach here if slotDetails exist
      // But if we do, we still can't use selectedDate for both start and end
      // Instead, calculate end date based on totalDays
      if (multiDayInfo.startTime && multiDayInfo.endTime) {
        const startTime = convertTo12HourFormat(multiDayInfo.startTime);
        const endTime = convertTo12HourFormat(multiDayInfo.endTime);
        
        // If we have totalDays, calculate the end date
        let endDate = dateObj;
        if (multiDayInfo.totalDays && multiDayInfo.totalDays > 1) {
          endDate = new Date(dateObj);
          endDate.setDate(endDate.getDate() + (multiDayInfo.totalDays - 1));
        }
        
        return {
          start: `${formatDate(dateObj)} ${startTime}`,
          end: `${formatDate(endDate)} ${endTime}`,
          isMultiDay: true
        };
      }
    }
  }
  
  // Handle single-day slots
  let startTime, endTime;
  
  if (typeof slot === 'string') {
    // Legacy string format: "09:00-13:00"
    const [start, end] = slot.split('-');
    startTime = start;
    endTime = end || calculateSingleDayEndTime(start, duration);
  } else if (slot && typeof slot === 'object') {
    // Object format
    if (slot.time) {
      startTime = slot.time;
      // Check if slot has originalSlot (single-day with end time)
      if (slot.originalSlot && typeof slot.originalSlot === 'string') {
        const [start, end] = slot.originalSlot.split('-');
        endTime = end || calculateSingleDayEndTime(startTime, duration);
        
        // If end time is 24:00 or 23:59 and duration exceeds available minutes per day, treat as multi-day
        if ((endTime === '24:00' || endTime === '23:59') && duration > availableMinutesPerDay) {
          // This is actually a multi-day booking - calculate proper end date
          const startDateParts = selectedDate.split('-').map(Number);
          let currentDate = new Date(startDateParts[0], startDateParts[1] - 1, startDateParts[2]);
          const startDate = new Date(currentDate);
          
          // Calculate remaining duration after first day
          const [startH, startM] = startTime.split(':').map(Number);
          const startMinutes = startH * 60 + startM;
          const firstDayBusinessHours = dayBusinessHours || getBusinessHoursForDate(format(startDate, 'yyyy-MM-dd'));
          
          // Calculate first day duration
          let firstDayEndMinutes;
          if (firstDayBusinessHours && firstDayBusinessHours.endTime) {
            const [endH, endM] = firstDayBusinessHours.endTime.split(':').map(Number);
            firstDayEndMinutes = endH * 60 + endM;
          } else {
            firstDayEndMinutes = 24 * 60; // End of day
          }
          
          const firstDayDuration = firstDayEndMinutes - startMinutes;
          let remainingDuration = duration - firstDayDuration;
          
          // Skip to next business day and continue calculating
          while (remainingDuration > 0) {
            // Move to next day
            currentDate.setDate(currentDate.getDate() + 1);
            
            // Skip weekends if blockWorkHoursOnly (check store or default to true)
            const dayOfWeek = currentDate.getDay();
            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
            const blockWorkHoursOnly = store.state.selectedInstall?.blockWorkHoursOnly !== false;
            
            if (isWeekend && blockWorkHoursOnly) {
              continue; // Skip weekend days
            }
            
            // Get business hours for this day
            const dayBusinessHoursForDate = getBusinessHoursForDate(format(currentDate, 'yyyy-MM-dd'));
            if (!dayBusinessHoursForDate && blockWorkHoursOnly) {
              continue; // Skip days without business hours
            }
            
            // Calculate available minutes for this day
            let dayAvailableMinutes;
            if (dayBusinessHoursForDate && dayBusinessHoursForDate.startTime && dayBusinessHoursForDate.endTime) {
              const dayStartMins = parseTimeToMinutes(dayBusinessHoursForDate.startTime.split(':').slice(0, 2).join(':'));
              const dayEndMins = parseTimeToMinutes(dayBusinessHoursForDate.endTime.split(':').slice(0, 2).join(':'));
              dayAvailableMinutes = dayEndMins - dayStartMins;
            } else {
              dayAvailableMinutes = 24 * 60; // Full day
            }
            
            // Use available minutes or remaining duration, whichever is smaller
            const dayDuration = Math.min(remainingDuration, dayAvailableMinutes);
            remainingDuration -= dayDuration;
            
            // If we've used all remaining duration, this is the end date
            if (remainingDuration <= 0) {
              const endDate = new Date(currentDate);
              const endDateBusinessHours = dayBusinessHoursForDate || getBusinessHoursForDate(format(endDate, 'yyyy-MM-dd'));
              
              // Calculate end time
              let endTimeMinutes;
              if (endDateBusinessHours && endDateBusinessHours.startTime) {
                const dayStartMins = parseTimeToMinutes(endDateBusinessHours.startTime.split(':').slice(0, 2).join(':'));
                endTimeMinutes = dayStartMins + dayDuration;
              } else {
                endTimeMinutes = dayDuration;
              }
              
              const endHours = Math.floor(endTimeMinutes / 60) % 24;
              const endMins = endTimeMinutes % 60;
              const calculatedEndTime = `${String(endHours).padStart(2, '0')}:${String(endMins).padStart(2, '0')}`;
              
              return {
                start: `${formatDate(startDate)} ${convertTo12HourFormat(startTime)}`,
                end: `${formatDate(endDate)} ${convertTo12HourFormat(calculatedEndTime)}`,
                isMultiDay: true
              };
            }
          }
        }
      } else if (slot.slot && typeof slot.slot === 'string') {
        // Handle {slot: "14:00-24:00", hasConflict: false} format from backend
        const [start, end] = slot.slot.split('-');
        startTime = start;
        endTime = end;
        
        // If end time is 24:00 or 23:59 and duration exceeds available minutes per day, treat as multi-day
        if ((endTime === '24:00' || endTime === '23:59') && duration > availableMinutesPerDay) {
          // This is actually a multi-day booking - calculate proper end date
          const startDateParts = selectedDate.split('-').map(Number);
          let currentDate = new Date(startDateParts[0], startDateParts[1] - 1, startDateParts[2]);
          const startDate = new Date(currentDate);
          
          // Calculate remaining duration after first day
          const [startH, startM] = startTime.split(':').map(Number);
          const startMinutes = startH * 60 + startM;
          const firstDayBusinessHours = dayBusinessHours || getBusinessHoursForDate(format(startDate, 'yyyy-MM-dd'));
          
          // Calculate first day duration
          let firstDayEndMinutes;
          if (firstDayBusinessHours && firstDayBusinessHours.endTime) {
            const [endH, endM] = firstDayBusinessHours.endTime.split(':').map(Number);
            firstDayEndMinutes = endH * 60 + endM;
          } else {
            firstDayEndMinutes = 24 * 60; // End of day
          }
          
          const firstDayDuration = firstDayEndMinutes - startMinutes;
          let remainingDuration = duration - firstDayDuration;
          
          // Skip to next business day and continue calculating
          while (remainingDuration > 0) {
            // Move to next day
            currentDate.setDate(currentDate.getDate() + 1);
            
            // Skip weekends if blockWorkHoursOnly (check store or default to true)
            const dayOfWeek = currentDate.getDay();
            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
            const blockWorkHoursOnly = store.state.selectedInstall?.blockWorkHoursOnly !== false;
            
            if (isWeekend && blockWorkHoursOnly) {
              continue; // Skip weekend days
            }
            
            // Get business hours for this day
            const dayBusinessHoursForDate = getBusinessHoursForDate(format(currentDate, 'yyyy-MM-dd'));
            if (!dayBusinessHoursForDate && blockWorkHoursOnly) {
              continue; // Skip days without business hours
            }
            
            // Calculate available minutes for this day
            let dayAvailableMinutes;
            if (dayBusinessHoursForDate && dayBusinessHoursForDate.startTime && dayBusinessHoursForDate.endTime) {
              const dayStartMins = parseTimeToMinutes(dayBusinessHoursForDate.startTime.split(':').slice(0, 2).join(':'));
              const dayEndMins = parseTimeToMinutes(dayBusinessHoursForDate.endTime.split(':').slice(0, 2).join(':'));
              dayAvailableMinutes = dayEndMins - dayStartMins;
            } else {
              dayAvailableMinutes = 24 * 60; // Full day
            }
            
            // Use available minutes or remaining duration, whichever is smaller
            const dayDuration = Math.min(remainingDuration, dayAvailableMinutes);
            remainingDuration -= dayDuration;
            
            // If we've used all remaining duration, this is the end date
            if (remainingDuration <= 0) {
              const endDate = new Date(currentDate);
              const endDateBusinessHours = dayBusinessHoursForDate || getBusinessHoursForDate(format(endDate, 'yyyy-MM-dd'));
              
              // Calculate end time
              let endTimeMinutes;
              if (endDateBusinessHours && endDateBusinessHours.startTime) {
                const dayStartMins = parseTimeToMinutes(endDateBusinessHours.startTime.split(':').slice(0, 2).join(':'));
                endTimeMinutes = dayStartMins + dayDuration;
              } else {
                endTimeMinutes = dayDuration;
              }
              
              const endHours = Math.floor(endTimeMinutes / 60) % 24;
              const endMins = endTimeMinutes % 60;
              const calculatedEndTime = `${String(endHours).padStart(2, '0')}:${String(endMins).padStart(2, '0')}`;
              
              return {
                start: `${formatDate(startDate)} ${convertTo12HourFormat(startTime)}`,
                end: `${formatDate(endDate)} ${convertTo12HourFormat(calculatedEndTime)}`,
                isMultiDay: true
              };
            }
          }
        }
      } else {
        endTime = calculateSingleDayEndTime(startTime, duration);
      }
    } else {
      // Fallback: use current time
      startTime = '09:00';
      endTime = calculateSingleDayEndTime(startTime, duration);
    }
  } else {
    // Fallback
    startTime = '09:00';
    endTime = calculateSingleDayEndTime(startTime, duration);
  }
  
  const formattedStartTime = convertTo12HourFormat(startTime);
  const formattedEndTime = convertTo12HourFormat(endTime);
  
  return {
    start: `${formatDate(dateObj)} ${formattedStartTime}`,
    end: `${formatDate(dateObj)} ${formattedEndTime}`,
    isMultiDay: false
  };
}
